
export default url => {
  return fetch(url)
    .then(res => res.json())
    .then(json => json)
    .catch(error => console.error(error));
};
